import React from 'react';

import {
  useTranslation,
} from 'react-i18next';

import '../pages/UpdateNoticePage.css';

export default function UpdateNoticeLayout({
  children,
  sidebar,
}) {
  const {
    t,
  } = useTranslation(
    'app',
  );

  return (
    <>
      <div
        className="updatenotice-page"
      >
        <main
          className="updatenotice-main"
        >
          <section
            className="updatenotice-hero"
          >
            <div
              className="updatenotice-hero-inner"
            >
              <span
                className="updatenotice-hero-eyebrow"
              >
                {'UPDATE NOTICE'}
              </span>

              <h1>
                {t(
                  'updatenotices.title',
                )}
              </h1>

              <p>
                {t(
                  'updatenotices.description',
                )}
              </p>
            </div>
          </section>

          <section
            className="updatenotice-body"
          >
            <div
              className="updatenotice-body-inner"
            >
              <div
                className="updatenotice-shell"
              >
                {sidebar && (
                  <aside
                    className="updatenotice-sidebar-area"
                  >
                    {sidebar}
                  </aside>
                )}

                <section
                  className="updatenotice-content-area"
                >
                  {children}
                </section>
              </div>
            </div>
          </section>
        </main>
      </div>
    </>
  );
}